export const Languages = [
    {//esp
        "leftMenuHome":"Home",
        "leftMenuAmenity":"Amenidades",
        "leftMenuNearme":"Puntos de interés",
        "leftMenuGallery":"Galería",
        "leftMenuContact":"Contacto",        
        "alertLoadingMessage": "Cargando...",
        "termsConditionsText": "NOTA GENERAL Los planos y renders contenidos son una representación digital del diseño, y pueden variar respecto a la licencia de construcción y producto final entregado. NOTA APARTAMENTOS: Los planos y renders contenidos son una representación digital del diseño, y pueden variar respecto al producto final entregado. Los muebles y enseres utilizados en los renders, son elementos de decoración que no hacen parte del apartamento. Las especificaciones de materiales pueden cambiar por similares de igual o mejor calidad, dependiendo del suministro y/o disponibilidad por parte de los proveedores.",
        "introButtonContinue": "Empezar",
        "buildingPointAlertButtonContinue": "Ingresar",
        "aptoPointAlertButtonContinue": "Ingresar",
        "buildingMenuFloorSubTilte": "Pisos",
        "aptoStatusAvailable": "Disponible",
        "aptoStatusUnavailable": "Vendido",
        "aptoStatusReserve": "Reservado",
        "genericSpecsTitle": "Especificaciones",
        "genericAddressText": "Dirección",
        "genericPhoneText": "Teléfono",
        "genericLocationText": "Ubicación",
        "genericAptoTitle": "Apto",
        "genericAptoTypeTitle": "Tipo",
        "genericAreaTitle": "Área Total",
        "genericRoomTitle": "Habitación",
        "genericRoomsTitle": "Habitaciones",
        "genericBathroomTitle": "Baño",
        "genericBathroomsTitle": "Baños",
        "genericAreaBalconyTitle": "Balcón",
        "genericNoAreaBalconyTitle": "Sin Balcón",
        "genericAreaTerraceTitle": "Terraza",
        "genericNoAreaTerraceTitle": "Sin Terraza",
        "genericAreaYardTitle": "Patio",
        "genericNoAreaYardTitle": "Sin Patio",
        "genericCostSimulatorButton": "Simulador",
        "genericDownloadBrochureButton": "Brochure",
        "generic360Button": "Recorrido Virtual",
        "contactTitle": "Contacto",
        "contactAddressText": "Sala de ventas",
        "contactIntro": "Si deseas recibr información personalizada sobre éste proyecto puedes compartir tus datos a continuación y te contactaremos.",
        "nearmeTransportTitle": "Transporte",
        "nearmeMallTitle": "Comercio",
        "nearmeEducationTitle": "Educación",
        "nearmeHealthTitle": "Salud",
        "costSimulatorTitle": "Simulador compra de vivienda",
        "costSimulatorInfoBuildingName": "Torre",
        "costSimulatorInfoFloorName": "Piso",
        "costSimulatorInfoAptoName": "Apartamento",
        "costSimulatorAptoTypeListItem": "Apto",
        "costSimulatorAptoCostTile": "Valor del inmueble",
        "costSimulatorSeparationValueText": "Valor de separación",
        "costSimulatorMinDownPaymentText": "Cuota inicial mínima 30%",
        "costSimulatorDownPaymentText": "Cuota inicial",
        "costSimulatorCreditUVRButton": "Crédito hipotecatio (UVR)",
        "costSimulatorCreditPesosButton": "Crédito hipotecatio (Pesos)",
        "costSimulatorHasSubsidyChecbox": "¿Vas a utilizar subsidio de vivienda?",
        "costSimulatorTermText": "Plazo de pago %value% meses",
        "costSimulatorCreditValueText": "Valor del crédito",
        "costSimulatorCreditTermsText": "**Cuota calculada con plan de amortización en pesos y tasa M.V del 13.48%",
        "costSimulatorSelectCreditTermTitle": "Selecciona el plazo del crédito",
        "costSimulatorYearText": "años",
        "costSimulatorMonthlyCreditValueText": "Valor mensual del crédito",
        "costSimulatorMonthlyRequiredIncomeValueText": "Ingresos Requeridos",
        "costSimulatorUVRText": "UVR",
        "costSimulatorCurrencyText": "Pesos",
        "costSimulatorWhatsAppButton": "Contactar",
        "searchAlertTitle": "Filtros de busqueda",
        "searchAlertBuildingsText": "Torres",
        "searchAlertBedroomsText": "Habitaciones",
        "searchAlertBathroomsText": "Baños",
        "searchAlertBalconyText": "Balcón",
        "searchAlertFloorText": "Piso",
        "searchAlertAreaText": "Área",
        "searchAlertTypologyText": "Tipología",
        "searchAlertResultText": "Resultado",
        "searchAlertResultPriceText": "Precio",
        "searchAlertResultStatusText": "Estado",
        "searchAlertResultNameText": "Apto",
        "searchAlertResultBuildingText": "T",
    },
    {//eng
        "leftMenuHome":"Home",
        "leftMenuNearme":"Nearme",
        "leftMenuGallery":"Gallery",
        "leftMenuContact":"Contact", 
        "introButtonContinue": "Continue",
        "buildingPointAlertButtonContinue": "Enter",
    }
];